<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新建问卷-->
      <Button type="primary" @click="addQuestionnaireBtn" v-if="getPermission('ymsQuestionnaire_create')">{{ $t('key1002974') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="600"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {amountHandel} from "@/utils/common";

export default {
  name: "questionnaireInvestigation",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002965'),
          key: 'questionnaireTitle',
          align: 'center',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002966'),
          key: 'status',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let typeList = [
              {type: 'error', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002967')},
              {type: 'success', text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002968')}
            ];
            let status = params.row.status;
            return h('Badge', {
              props: {
                status: typeList[status].type,
                text: typeList[status].text || '--'
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002969'),
          key: 'pageviewsPv',
          align: 'center',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002970'),
          key: 'recoveryPv',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let num = 0;
            let pageviewsPv = Number(params.row.pageviewsPv) || 0;
            let recoveryPv = Number(params.row.recoveryPv) || 0;
            if (recoveryPv !== 0) {
              num = (recoveryPv / pageviewsPv) * 100;
            }
            return h('span', amountHandel(num) + '%');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002971'),
          key: 'updatedTime',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 210,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsQuestionnaire_update'),
                    clickFn: () => {
                      const {href} = this.$router.resolve({
                        path: '/editQuestionnaire',
                        query: {
                          ymsQuestionnaireId: params.row.ymsQuestionnaireId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002879'),
                    show: v.getPermission('ymsQuestionnaire_queryQuantityStatistics'),
                    clickFn: () => {
                      const {href} = v.$router.resolve({
                        path: '/questionnaireStatistics',
                        query: {
                          ymsQuestionnaireId: params.row.ymsQuestionnaireId
                        }
                      });
                      window.open(href, '_blank');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsQuestionnaire_enable'),
                    clickFn: () => {
                      v.enableDisableBtn('enable', params.row.ymsQuestionnaireId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && v.getPermission('ymsQuestionnaire_disable'),
                    color: '#ed4014',
                    clickFn: () => {
                      v.enableDisableBtn('disable', params.row.ymsQuestionnaireId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsQuestionnaire_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsQuestionnaire_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.total = data.total;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新建问卷
    addQuestionnaireBtn() {
      const {href} = this.$router.resolve({
        path: '/addQuestionnaire'
      });
      window.open(href, '_blank');
    },
    // 启用、停用问卷调查
    enableDisableBtn(type, ymsQuestionnaireId) {
      let v = this;
      // 启用
      if (type === 'enable') {
        v.axios.put(api.put_ymsQuestionnaire_enable + ymsQuestionnaireId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
            v.pageParamsStatus = true;
          }
        });
      }
      // 停用
      else {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002972'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002973'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(api.put_ymsQuestionnaire_disable + ymsQuestionnaireId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                v.pageParamsStatus = true;
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>

<style scoped>

</style>
